export default "__VITE_ASSET__Ba2H1VbR__"